import firebase from "./firebase";

// Create a root reference
var storage = firebase.storage().ref();

if ( process.env.VUE_APP_PRODUCTION === 'false' && process.browser ) {
  window.gpdev.storage = storage;
}

export default storage;
